import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=e74e082a&"
import script from "./MentionList.vue?vue&type=script&lang=ts&"
export * from "./MentionList.vue?vue&type=script&lang=ts&"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=e74e082a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports